import { toSubUnit, toUnit } from '@99designs/spa-common';
import type { CurrencyCode } from '@99designs/i18n';
import type { Money } from '../components/Price';

export interface ExchangeRate {
    rate: number;
    currency: CurrencyCode;
}

export function convertUSDToLocalisedAmountInCents(
    amountInCents: number,
    { currency, rate }: ExchangeRate
): Money {
    return {
        currency,
        amountInCents: amountInCents * rate,
    };
}

export const roundNumberToNearestNine = (amount: number) => {
    if (amount <= 0 || amount % 10 === 9) {
        return amount;
    }

    return Math.round(amount / 10) * 10 - 1;
};

export const roundAmountInCentsToNearestNine = (amountInCents: number, currency: CurrencyCode) => {
    if (amountInCents <= 0 || amountInCents % 10 === 9) {
        return amountInCents;
    }

    const wholeAmountRoundedToNearestNine =
        Math.round(toUnit(amountInCents, currency) / 10) * 10 - 1;

    return toSubUnit(wholeAmountRoundedToNearestNine, currency);
};

export const roundAmountInCentsToWholeAmount = (amountInCents: number, currency: CurrencyCode) => {
    return Math.round(toUnit(amountInCents, currency));
};
